
export enum CollectionsMutationTypes {
  SET_COLLECTIONS = 'SET_COLLECTIONS',
}
